import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: "app-advisor",
    templateUrl: "./advisor.component.html",
    styleUrls: ["./advisor.component.css"],
    standalone: false
})
export class AdvisorComponent {

  // #region Propiedades del componente
  routes: object[] = [];
  // #endregion

  constructor(private router: Router) {
  }
}
